<template>
  <div class="image_requests_index">
    <page-header :title="$tc('imageRequest.name', 2)">
    </page-header>
    <page-content>
        <div v-if="loading" class="text-center py-4">
          <i class="fa fa-spinner fa-spin"></i>
        </div>
        <div v-else>
          <div class="row">
            <div class="col-md-8 offset-md-2">
              <div v-for="(item, idx) in items" :key="item.uuid || idx">
                <ntm-block>
                  <div class="mb-2">
                    <p v-if="item.user" class="mb-2 text-center">
                      <strong>Requested by:</strong> {{ item.user.name }}
                      <span v-if="item.user.email"> ({{ item.user.email }})</span>
                    </p>
                    <p v-if="item" class="mb-2 text-center">
                      <strong>{{ $tc('player.name', 1) }}: </strong> {{ item.name }}
                    </p>
                  </div>
                  <div class="row text-center mb-3 d-flex justify-content-center" style="gap: 10px">
                    <div v-if="item.profile">
                      <h5 class="mb-2">{{$t('imageRequest.current')}}</h5>
                      <img v-if="item.profile" :src="item.profile" alt="" class="rounded" style="max-width: 100%; max-height: 300px;">
                    </div>
                    <div>
                      <h5 class="mb-2">{{$t('imageRequest.requested')}}</h5>
                      <img :src="item.image" alt="" class="rounded" style="max-width: 100%; max-height: 300px;">
                    </div>
                  </div>
                  <div class="text-center mb-3">
                    <button class="btn btn-success mr-2" :disabled="processing[item.uuid]" @click="accept(item)">
                      <i v-if="processing[item.uuid] && processing[item.uuid] === 'accept'" class="fa fa-spinner fa-spin"></i>
                      <i v-else class="fa fa-check"></i>
                    </button>
                    <button class="btn btn-danger" :disabled="processing[item.uuid]" @click="decline(item)">
                      <i v-if="processing[item.uuid] && processing[item.uuid] === 'decline'" class="fa fa-spinner fa-spin"></i>
                      <i v-else class="fa fa-times"></i>
                    </button>
                  </div>
                </ntm-block>
              </div>
            </div>
          </div>

          <div v-if="model.meta" class="row mt-3 justify-content-between align-items-center">
            <div class="col-auto">
              <strong>{{ model.meta.current_page }}</strong> / <strong>{{ model.meta.last_page }}</strong>
            </div>
            <div class="col-auto">
              <div class="btn-group">
                <button class="btn btn-secondary" :disabled="page <= 1" @click="setPage(page - 1)">
                  <i class="fa fa-angle-left"></i>
                </button>
                <button class="btn btn-secondary" :disabled="page >= model.meta.last_page" @click="setPage(page + 1)">
                  <i class="fa fa-angle-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
    </page-content>
  </div>
</template>
<script>
import ImageRequestService from '@/services/imageRequests.service'
import basicIndexMixin from '@/mixins/basic.index.mixin'
import { useImageRequest } from '@/use/useImageRequest'
import { useRouteQuery } from '@/use/useRouteQuery'

export default {
  mixins: [basicIndexMixin],
  data () {
    return {
      processing: {}
    }
  },
  setup () {
    const page = useRouteQuery('page', 1)
    const { fetchImageRequestsCount } = useImageRequest()
    return { fetchImageRequestsCount, page }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      console.log(this.page)
      ImageRequestService.index(this.page).then((res) => {
        this.setData(res.data)
      })
    },
    accept (item) {
      if (!item?.uuid) return
      this.$set ? this.$set(this.processing, item.uuid, 'accept') : (this.processing[item.uuid] = 'accept')
      ImageRequestService.accept(item.uuid).then(() => {
        this.fetchImageRequestsCount()
        this.fetchData()
      }).finally(() => {
        this.$delete ? this.$delete(this.processing, item.uuid) : delete this.processing[item.uuid]
      })
    },
    decline (item) {
      if (!item?.uuid) return
      this.$set ? this.$set(this.processing, item.uuid, 'decline') : (this.processing[item.uuid] = 'decline')
      ImageRequestService.decline(item.uuid).then(() => {
        this.fetchImageRequestsCount()
        this.fetchData()
      }).finally(() => {
        this.$delete ? this.$delete(this.processing, item.uuid) : delete this.processing[item.uuid]
      })
    }
  },
  computed: {
    items () {
      return (this.model && this.model.data) ? this.model.data : []
    }
  }
}
</script>
